<template>
  <div>
    <v-alert
      :style="statusStyle"
      border
      density="comfortable"
      icon="mdi-swap-horizontal"
      variant="flat">
      <div class="d-flex flex-column ga-1">
        <div class="font-weight-bold">{{ action.label }}</div>
        <div class="text-body-2">Підтвердіть зміну статусу інциденту.</div>
      </div>
    </v-alert>

    <b-textarea
      v-if="action.commentRequired"
      v-model="comment"
      :error-messages="getErrorMessages(v$.comment)"
      class="mt-4"
      label="Коментар"
      rows="4"
      @blur="v$.comment.$touch()"></b-textarea>
  </div>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue'
import { useVuelidate } from '@vuelidate/core'
import { required } from '@vuelidate/validators'
import { getErrorMessages } from 'best-modules/utils'
import { BTextarea } from 'best-modules/components'
import type { Dialog } from '@/dialog'
import type { IncidentStatusPayload } from '@/utils/types/incident'
import { getIncidentStatusChipStyle } from '@/pages/operation-risk/incidents/constants'

defineOptions({
  name: 'IncidentSetStatus',
})

const props = defineProps<{
  dialog: Dialog
}>()

const action = props.dialog.dialogData.action as {
  statusId: number
  label: string
  color: string
  commentRequired?: boolean
}
const comment = ref<string | null>(null)
const statusStyle = computed(() => {
  return getIncidentStatusChipStyle(action.statusId)
})

const rules = computed(() => ({
  comment: action.commentRequired ? { required } : {},
}))

const v$ = useVuelidate(rules, { comment })

const submit = (): IncidentStatusPayload => {
  return {
    statusId: action.statusId,
    comment: action.commentRequired ? comment.value : null,
  }
}

defineExpose({
  v$,
  submit,
})
</script>
